import { Header } from "@components:Header";
import { SVGInternalIcon } from "@components:SVGInternalIcon";
import { SwitchPage } from "@components:SwitchPage";
import { BotSelectionPersistent } from "@modules:BotSelection/BotSelection";
import { Box, Container, Tab, Tabs, Typography } from "@mui/material";
import { StatusTab } from "@pages:app/audio/components/Status";
import { UploadTab } from "@pages:app/audio/components/Upload";
import { SyntheticEvent, useState } from "react";

export const Audio = () => {
  const [activeTab, setActiveTab] = useState<"transcribe" | "status">(
    "transcribe",
  );

  const handleTabChange = (
    _event: SyntheticEvent,
    newValue: "transcribe" | "status",
  ) => {
    setActiveTab(newValue);
  };

  return (
    <Box
      sx={{
        background: (theme) => theme.palette.background.default,
        minHeight: "100vh",
        padding: "12px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          borderRadius: "30px",
          background: (theme) => theme.palette.common.white,
          flexGrow: 1,
        }}
      >
        <Header
          sx={{
            background: (theme) => theme.palette.common.white,
            borderTopLeftRadius: "30px",
            borderTopRightRadius: "30px",
          }}
          rightSide={
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Box sx={{ paddingX: "0.5rem" }}>
                <BotSelectionPersistent />
              </Box>
              <SwitchPage />
            </Box>
          }
          leftSide={
            <Box
              sx={{
                marginLeft: "1.5rem",
              }}
            >
              <SVGInternalIcon
                icon="nemoIcon"
                sx={{
                  width: "120px",
                  height: "120px",
                }}
              />
            </Box>
          }
        />
        <Box
          sx={{
            flex: "1 1 0% !important",
            paddingTop: "100px",
          }}
        >
          <Typography
            sx={{
              color: (theme) => theme.palette.text.primary,
              fontWeight: "bold",
              fontSize: "32px",
              lineHeight: "32px",
              textAlign: "center",
            }}
          >
            Nemo Audio Transcription
          </Typography>
          <Container
            maxWidth="lg"
            sx={{
              paddingTop: "2rem",
            }}
          >
            <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 4 }}>
              <Tabs
                value={activeTab}
                onChange={handleTabChange}
                aria-label="transcription tabs"
                sx={{
                  "& .MuiButtonBase-root": {
                    textTransform: "capitalize",
                  },
                }}
              >
                <Tab label="Transcribe Audio" value="transcribe" />
                <Tab label="Task Status" value="status" />
              </Tabs>
            </Box>
            <UploadTab
              sx={{ display: activeTab === "transcribe" ? "block" : "none" }}
            />
            <StatusTab
              sx={{ display: activeTab === "status" ? "block" : "none" }}
            />
          </Container>
        </Box>
      </Box>
    </Box>
  );
};
